<template>
  <div>
    <tree-wiki />
    <transition name="top" appear>
      <q-page-sticky position="top-right" :offset="[8, 8]" v-if="isWikiAdmin">
        <q-btn round color="secondary" @click="doArticleAdd" icon="add"/>
      </q-page-sticky>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TreeWiki from 'components/tree-wiki.vue';

export default {
  components: { TreeWiki },
  name: 'wikiList',
  computed: {
    ...mapGetters({
      isWikiAdmin: 'wiki/isWikiAdmin',
    }),
  },
  created() {
    // this.$store.dispatch('wiki/loadWikis');
  },
  methods: {
    doArticleAdd() {
      this.$router.push('/wikinew/root');
    },
  },
};
</script>

<style lang="stylus">
  .my-padding
    padding 1rem 1rem
    margin auto
</style>



// WEBPACK FOOTER //
// src/pages/wiki-list.vue